// extracted by mini-css-extract-plugin
export default {"wrapper":"Content_wrapper__iV03G","container":"Content_container__Zx-rf","shadow":"Content_shadow__5EtmY","content":"Content_content__vxBt3"};